module.exports = __webpack_public_path__ + "img/list-icon.4a1851a9.svg";